import { jsx as _jsx } from "react/jsx-runtime";
import { useMediaDevice } from '@kubit/web-ui-components/hooks/useMediaDevice';
import { useScrollPosition } from '@kubit/web-ui-components/hooks/useScrollPosition';
import { useStyles } from '@kubit/web-ui-components/hooks/useStyles';
import React from 'react';
import { STYLES_NAME } from '../../constants/stylesName/stylesName';
import { HeaderStandAlone } from './headerStandAlone';
const HeaderComponent = ({ variant, ctv, ...props }, ref) => {
    const styles = useStyles(STYLES_NAME.HEADER, variant, ctv);
    const device = useMediaDevice();
    const scroll = useScrollPosition();
    return (_jsx(HeaderStandAlone, { ...props, ref: ref, device: device, scrolling: scroll > 0, styles: styles }));
};
export const Header = React.forwardRef(HeaderComponent);
//# sourceMappingURL=header.js.map